import { render } from "./TermsAndConditions.vue?vue&type=template&id=7f0baeda&scoped=true&ts=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=7f0baeda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0baeda"]])

export default __exports__